import { render, staticRenderFns } from "./TaskDeleteForm.vue?vue&type=template&id=32488b82"
import script from "./TaskDeleteForm.vue?vue&type=script&lang=js"
export * from "./TaskDeleteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports